import React, { useContext } from "react";
import { Avatar, Popover } from "antd";
import { context } from '../../context'

import { randomColor } from "../../constants/values";

import styles from './index.module.scss';

const UserInfo = () => {

  const { state, actions } = useContext(context)
  const { authUser } = state

  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li>My Account</li>
      <li>Connections</li>
      <li onClick={() => actions.userSignOut()} >
        Logout
      </li>
    </ul>
  );

  return (
    <Popover overlayClassName="gx-popover-horizantal"
      placement="bottom" content={userMenuOptions}
      trigger="click">
      <div className={styles.avatar_top_header_container}>
        <div>
          <Avatar style={{ backgroundColor: randomColor(authUser?.name[0].toUpperCase()) }}
            className="gx-avatar gx-pointer" alt="" >
            {/* {authUser && authUser?.name.toUpperCase()} */}
            {authUser && authUser?.name[0].toUpperCase()}
          </Avatar>
        </div>
        <div className={styles.name_box}>
          <p>{authUser?.name}</p>
          <p>{authUser?.lastName}</p>
        </div>
      </div>
    </Popover>
  )

}

export default UserInfo;
